import JsPDF from "jspdf";
import html2canvas from "html2canvas";

// Capture a DOM element and save it as a multi-page US-Letter PDF, slicing tall content
// across pages. Shared by the ETT report page and the prep-program report modal.
export async function exportElementToPdf(element, fileName) {
    if (!element) return;
    const canvas = await html2canvas(element, { scale: 2 });

    const pageWidth = 612; // US Letter, pt
    const pageHeight = 792;
    const margin = 36; // 0.5 inch
    const usableWidth = pageWidth - margin * 2;
    const usableHeight = pageHeight - margin * 2;

    const imgScaledWidth = usableWidth;
    const imgScaledHeight = (canvas.height * usableWidth) / canvas.width;

    const pdf = new JsPDF({ orientation: "p", unit: "pt", format: "letter" });
    let yRemaining = imgScaledHeight;
    let srcY = 0;
    let page = 0;

    while (yRemaining > 0) {
        if (page > 0) pdf.addPage("letter", "p");
        const sliceHeight = Math.min(usableHeight, yRemaining);
        const srcSliceHeight = (sliceHeight / imgScaledHeight) * canvas.height;

        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = srcSliceHeight;
        sliceCanvas.getContext("2d").drawImage(canvas, 0, srcY, canvas.width, srcSliceHeight, 0, 0, canvas.width, srcSliceHeight);

        pdf.addImage(sliceCanvas.toDataURL("image/png"), "PNG", margin, margin, imgScaledWidth, sliceHeight);
        srcY += srcSliceHeight;
        yRemaining -= sliceHeight;
        page++;
    }

    pdf.save(fileName);
}
